import Button, { ButtonProps } from '@mui/material/Button';
import React from 'react';

const DestructiveButton: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Button {...rest} variant="contained" color="error">
    {children}
  </Button>
);

export default DestructiveButton;
